import Home from '@/views/Home.vue';
import Login from '@/views/Login.vue';
import Region from '@/views/Region.vue';
import Account from '@/views/Account.vue';
import LostPassword from '@/views/LostPassword.vue';
import AdminActivate from '@/views/AdminActivate.vue';
import ManagementUser from '@/views/Admin/ManagementUser.vue';
import ManagementRegion from '@/views/Admin/ManagementRegion.vue';
import ManagementSite from '@/views/Admin/ManagementSite.vue';
import ManagementSmartTx from '@/views/Admin/ManagementSmartTx.vue';
import Vue from 'vue';
import Router from 'vue-router';
import Session from './plugins/session';
import store from './store/store';

Vue.use(Router);

/**
 * Router
 */
const router: Router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: '/',
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/lost-password',
      name: 'lost-password',
      component: LostPassword,
    },
    {
      path: '/admin-activate/:_token',
      name: 'admin-activate',
      component: AdminActivate,
      props: true,
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        isPrivate: true,
        layout: 'connected-layout',
        title: 'home-title',
      },
    },
    {
      path: '/my-account',
      name: 'my-account',
      component: Account,
      meta: {
        isPrivate: true,
        layout: 'connected-layout',
        title: 'home-title',
      },
    },
    {
      path: '/regions/:_idRegion/sites/:_idSite',
      name: 'regions',
      component: Region,
      props: true,
      meta: {
        isPrivate: true,
        layout: 'connected-layout',
        title: 'region-title',
      },
    },
    {
      path: '/management-user',
      name: 'management-user',
      component: ManagementUser,
      meta: {
        isPrivate: true,
        layout: 'connected-layout',
        title: 'management-user',
      },
    },
    {
      path: '/management-region',
      name: 'management-region',
      component: ManagementRegion,
      props: true,
      meta: {
        isPrivate: true,
        layout: 'connected-layout',
        title: 'management-region',
      },
    },
    {
      path: '/management-site',
      name: 'management-site',
      component: ManagementSite,
      props: true,
      meta: {
        isPrivate: true,
        layout: 'connected-layout',
        title: 'management-site',
      },
    },
    {
      path: '/management-smart-tx',
      name: 'management-smart-tx',
      component: ManagementSmartTx,
      props: true,
      meta: {
        isPrivate: true,
        layout: 'connected-layout',
        title: 'management-smart-tx',
      },
    },
  ],
});

/**
 * Before each route
 */
router.beforeEach((to, from, next) => {
  // Session plugin
  const session: Session = Vue.$session;

  // Check if user authticated
  const isAuthenticated = session.isAuthenticated();

  // Check meta private or go login page
  if (to.meta.isPrivate && !isAuthenticated) {
    return next('/login');
  }

  store.commit('alert/HIDE');

  // Goto next route
  next();
});

export default router;
